.menuDropdown {
	padding: 16px;
	border: 1px solid var(--mantine-color-gray-3);
	[data-menu-dropdown] {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}
}
.menuItem {
	transition: background-color 0.1s ease-in-out;
	gap: 9px;
	padding: 7px 8px;
	min-height: 38px;
	&:hover {
		background-color: var(--mantine-color-gray-1);
	}
}
.menuItemLabel {
	font-weight: 500;
	color: var(--mantine-color-dimmed);
	font-size: var(--mantine-font-size-md);
	line-height: var(--mantine-line-height-md);
}
.menuDivider {
	margin-block: 4px;
	border-color: var(--mantine-color-gray-3);
}
.menuItemSection {
	margin-right: 0;
}

.modalRoot {
	* {
		box-sizing: border-box;
	}
}

.modalInner {
	@include screen-md {
		padding: 0;
	}
}
.modalContent {
}
.modalBody {
}
.modalHeader {
	margin-inline: auto;
	position: static;
	height: $modal-header-height;
}
.modalClose {
	background-color: var(--mantine-color-gray-1);
	border-radius: 50%;
	width: 32px;
	transition: $transition;
	height: 32px;
	svg {
		width: 22px !important;
		height: 22px !important;
		path {
			fill: $color-primary;
		}
	}
	&:hover {
		background-color: var(--mantine-color-gray-2);
	}
}
.modalTitle {
	font-weight: bold;
	font-size: var(--mantine-font-size-xl);
}

.paginationControl {
	border-color: var(--mantine-color-gray-3);
	box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
	color: $color-secondary;

	&[data-active] {
		background-color: $color-primary;
		border: none;
		&:hover {
			background-color: $color-primary !important;
		}
	}
}
.paginationDots {
	align-items: flex-end;
}

.nativeSelectInput {
	height: unset;
}

.selectInput {
	padding-inline: 20px;
	background-color: $white;

	&:focus {
		border-color: $color-primary;
	}

	&::placeholder {
		color: var(--mantine-color-dimmed);
	}
}
.selectEmpty {
	font-size: initial;
	color: var(--mantine-color-dimmed);
}
.selectDropdown {
	border-radius: var(--mantine-spacing-xs);
	padding: var(--mantine-spacing-xs) !important;
}
.selectOption {
	padding: 8px 20px;
	&[data-checked] {
		background-color: var(--mantine-color-gray-3);
		color: $black;

		&:hover {
			background-color: var(--mantine-color-gray-3);
			color: $black;
		}
	}

	&:hover {
		background-color: var(--mantine-color-gray-1);
		color: $black;
	}

	&[data-disabled] {
		cursor: not-allowed;
	}
}

.tooltipTooltip {
	padding: 2px 8px;
	color: var(--mantine-color-gray-2);
	text-align: center;
}

.radioRoot {
	&[data-checked='true'] {
		.radioBody {
		}
	}
}
.radioBody {
	transition: $transition;
	align-items: center;
	padding: 8px;
	word-break: keep-all;
}
.radioLabelWrapper {
	flex-grow: 1;
}
.radioLabel {
	padding-left: 8px;
	font-size: var(--mantine-font-size-md);
	line-height: var(--mantine-line-height-md);
	color: var(--mantine-color-dimmed);

	&[data-disabled='true'] {
		opacity: 0.5;
		div {
			cursor: not-allowed;
		}
	}
}

.checkboxInner {
	margin-top: 3px;
}
.checkboxLabel {
	padding-left: 8px;
	font-size: var(--mantine-font-size-md);
	line-height: var(--mantine-line-height-md);
}

.textInputInput {
	border: 1px solid var(--mantine-color-gray-5) !important;
	background-color: white;

	&:focus {
		border-color: var(--mantine-color-primary) !important;
		outline: none;
	}
}
.textInputLabel {
	margin-bottom: 4px;
	color: var(--mantine-color-dimmed);
}
.textInputError {
	font-size: var(--mantine-font-size-xs);
	// color: $danger;
}

.textareaInput {
	transition: all $transition;
	padding-inline: 16px;
	background-color: $white;
	border: none;
	border-bottom: 1px solid var(--mantine-color-gray-3);
	padding-top: 15.5px;
}

.passwordInputInput {
	transition: all $transition;
	background-color: var(--mantine-color-gray-1);
	border: none;
	border-bottom: 1px solid var(--mantine-color-gray-3);
	input {
		padding-inline: 24px 42px;
		color: var(--mantine-color-dimmed);
		width: 100%;
		height: 100%;
		&::placeholder {
			color: var(--mantine-color-dimmed);
		}
	}
	&:focus-within {
		border-color: $black;
		background-color: transparent;
	}
	&:has(:not(:placeholder-shown)) {
		border-color: $black;
		background-color: transparent;
	}
}
.passwordInputSection {
	width: fit-content;
	padding-right: 16px;
	button {
		width: 20px;
		padding: 0;
		&:hover {
			background-color: transparent;
		}
	}
}
.passwordInputIconRevealed {
	position: relative;
	&::after {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 2px;
		height: 24px;
		transform: translate(-50%, -50%);
		rotate: 45deg;
		transform-origin: top left;
		content: '';
	}
}
.passwordInputError {
	font-size: var(--mantine-font-size-xs);
}

.drawerBody {
	padding-inline: var(--mantine-spacing-xl);
}

.drawerInner {
	top: $modal-header-height;
}
.drawerHeader {
	align-items: baseline;
	padding-inline: var(--mantine-spacing-xl);
	min-height: unset;
}
.drawerContent {
	height: calc(100% - var(--mantine-spacing-md));
}
.drawerTitle {
	font-weight: bold;
	padding-right: 24px;
	letter-spacing: -0.25px;
}
.drawerClose {
	color: var(--mantine-color-dimmed);
	&:hover {
		background-color: transparent;
	}
}

.dividerLabel {
	font-size: var(--mantine-font-size-xs);
	font-weight: bold;
}

.datePickerDay {
	&[data-in-range]:not([data-selected]) {
		&:not([data-selected]) {
			background-color: var(--mantine-color-gray-3);
		}
	}
	&[data-in-range][data-selected]:hover {
		background-color: $color-primary;
	}
	&[data-weekend]:not([data-selected]) {
		// color: $danger;
	}
}

.badgeLabel {
	text-transform: none;
}

.sliderRoot {
	padding-inline: 0.75rem;
}
.sliderMarkLabel {
	font-weight: bold;
}
.sliderBar {
	background-color: $color-secondary;
}
.sliderThumb {
	border-color: $color-primary;
	box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
}
.sliderTrack {
	&::before {
	}
}
.sliderLabel {
	padding-inline: 6px;
}

.notificationRoot {
	animation: fadeIn $transition;
	gap: var(--mantine-spacing-sm);
}
.notificationIcon {
	margin: 0;
}
.notificationCloseButton {
	svg {
		width: 20px;
		height: 20px;
	}
	path {
	}
}
.notification {
	&Danger {
		background-color: $color-red-0;
		&Description {
			color: $color-red-8;
		}
		&Icon {
			background-color: $color-red-0;
		}
	}
	&Info {
		background-color: $color-blue-0;
		&Description {
			color: $color-blue-6;
		}
		&Icon {
			background-color: $color-blue-0;
		}
	}
	&Success {
		background-color: $color-teal-0;
		&Description {
			color: $color-teal-6;
		}
		&Icon {
			background-color: $color-teal-0;
		}
	}
}

.accordionContent {
	padding: var(--mantine-spacing-sm) var(--mantine-spacing-xs);
}
.accordionItem {
	border: none;
	background-color: #f3f3f3;
}
.accordionControl {
	border: 1px solid var(--mantine-color-gray-3);
	transition: $transition;
	padding: 11px 0.5rem;
	gap: 0.5rem;
	flex-wrap: wrap;
	&[data-active='true'] {
		background-color: $white;
	}
}
.accordionLabel {
	padding: 0;
	font-weight: 600;
	min-width: 40%;
	font-size: var(--mantine-font-size-lg);
}
.accordionChevron {
	margin: 0;

	path {
		transition: $transition;
		stroke: $color-dark-3;
	}
	&[data-rotate='true'] {
		path {
		}
	}
}

.popoverDropdown {
	border: 1px solid var(--mantine-color-gray-3);
	padding: var(--mantine-spacing-sm);
	cursor: initial;
}

.segmentedControlRoot {
	background-color: $white;
}
.segmentedControlLabel {
}

.chipLabel {
	border: 1px solid var(--mantine-color-gray-3);
	background-color: #fff;

	&[data-checked='true'] {
		color: $black;
		background-color: $color-primary;
		border-color: $color-primary;
	}
	svg {
		color: $color-secondary;
	}
}
